<template>
    <div v-if="!accepted && !rejected" class="cookie-notice">
        <p>{{ $t("HELP_LGPD").Cookies_Notice }}</p>
        <button @click="acceptCookies" class="vs-button vs-button-primary vs-button-filled">{{ $t("HELP_LGPD").Accept_Cookies }}</button>
        <button @click="rejectCookies" class="vs-button vs-button-primary vs-button-filled">{{ $t("HELP_LGPD").Reject_Cookies }}</button>
        <button @click="openPrivacyPolicy" class="vs-button vs-button-primary vs-button-filled">{{ $t("HELP_LGPD").Privacy_Policy }}</button>
        <vs-popup v-if="displayPopupPrivacyPolicy" :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPopupPrivacyPolicy" class="privacy-policy-modal" @close="closePrivacyPolicy">
            <privacy-policy v-if="displayPopupPrivacyPolicy" @close="displayPopupPrivacyPolicy=!displayPopupPrivacyPolicy"></privacy-policy>
        </vs-popup>
    </div>
    
</template>

<script>
import PrivacyPolicy from '../../views/pages/help/PrivacyPolicy.vue';


export default {
    components: {
        PrivacyPolicy
    },
    data() {
        return {
            accepted: false,
            rejected: false,
            displayPopupPrivacyPolicy: false
        };
    },
    methods: {
        openPrivacyPolicy() {
            this.displayPopupPrivacyPolicy = true;
            console.log('Opening Privacy Policy', this.displayPopupPrivacyPolicy);
            setTimeout(() => {
                this.$forceUpdate();
            }, 500)
        },
        closePrivacyPolicy() {
            this.displayPopupPrivacyPolicy = false;
            console.log('Closing Privacy Policy', this.displayPopupPrivacyPolicy);
            setTimeout(() => {
                this.$forceUpdate();
            }, 500)
        },
        acceptCookies() {
            this.accepted = true;
            this.$cookies.set('cookies_accepted', true);
            console.log("Cookies Accepted:", this.$cookies.get('cookies_accepted'));
            // this.$emit("cookies-accepted");
            this.closePrivacyPolicy()
            console.log('Accepting Cookies', this.displayPopupPrivacyPolicy);
            setTimeout(() => {
                this.$forceUpdate();;
            }, 500)
        },
        rejectCookies() {
            this.rejected = true;
            this.$cookies.set('cookies_accepted', false);
            // this.$emit("cookies-rejected");
            this.closePrivacyPolicy();
            console.log('Rejecting Cookies', this.displayPopupPrivacyPolicy);
            setTimeout(() => {
                this.$forceUpdate();;
            }, 500)
        },
    },
    mounted() {
    },
};
</script>

<style>
.cookie-notice {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 10px;
    width: 100%;
    padding: 10px;
    background-color: #e9e7e7f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    z-index: 999999;
    font-size: 16px;
}
</style>
